import { colors } from '../theme';

const styles = {
  skeleton: {
    backgroundColor: colors.gray200,
    borderRadius: '19px',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
  line: {
    height: '1rem',
    marginBottom: '0.5rem',
  },
  circle: {
    borderRadius: '50%',
  },
  rectangle: {
    borderRadius: '19px',
  },
};

function SkeletonLoader({ type = 'line', width = '100%', height = '1rem', count = 1, className = '', variant = null }) {
  // Variant-specific styles
  const variantStyles = {
    table: {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      gap: '1rem',
      padding: '1rem',
      borderBottom: `1px solid ${colors.gray200}`,
    },
    card: {
      padding: '1rem',
      borderRadius: '19px',
      border: `1px solid ${colors.gray200}`,
      marginBottom: '0.5rem',
    },
    form: {
      marginBottom: '1rem',
    },
    list: {
      padding: '0.75rem',
      borderBottom: `1px solid ${colors.gray200}`,
    },
  };

  // If variant is specified, render variant-specific skeleton
  if (variant && variantStyles[variant]) {
    return (
      <>
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.skeleton,
              ...variantStyles[variant],
              marginBottom: index < count - 1 ? '0.5rem' : 0,
            }}
            className={className}
            aria-hidden="true"
          >
            {variant === 'table' && (
              <>
                <div style={{ ...styles.skeleton, height: '1rem', width: '60%' }} />
                <div style={{ ...styles.skeleton, height: '1rem', width: '80%' }} />
                <div style={{ ...styles.skeleton, height: '1rem', width: '40%' }} />
              </>
            )}
            {variant === 'card' && (
              <>
                <div style={{ ...styles.skeleton, height: '1.25rem', width: '40%', marginBottom: '0.5rem' }} />
                <div style={{ ...styles.skeleton, height: '1rem', width: '100%', marginBottom: '0.25rem' }} />
                <div style={{ ...styles.skeleton, height: '1rem', width: '80%' }} />
              </>
            )}
            {variant === 'form' && (
              <>
                <div style={{ ...styles.skeleton, height: '0.875rem', width: '30%', marginBottom: '0.5rem' }} />
                <div style={{ ...styles.skeleton, height: '2.5rem', width: '100%' }} />
              </>
            )}
            {variant === 'list' && (
              <>
                <div style={{ ...styles.skeleton, height: '1rem', width: '70%', marginBottom: '0.25rem' }} />
                <div style={{ ...styles.skeleton, height: '0.875rem', width: '50%' }} />
              </>
            )}
          </div>
        ))}
        <style>{`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </>
    );
  }

  // Default behavior (line/circle/rectangle)
  const baseStyle = {
    ...styles.skeleton,
    ...styles[type],
    width,
    height,
  };

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            ...baseStyle,
            marginBottom: index < count - 1 ? '0.5rem' : 0,
          }}
          className={className}
          aria-hidden="true"
        />
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
}

export default SkeletonLoader;

